import "core-js/modules/es.array.concat.js";
import classnames from 'classnames';
import { Text } from "../Text/Text/Text";
import styles from "./Coin.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export var Coin = function Coin(_ref) {
  var value = _ref.value,
    secondValue = _ref.secondValue,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size;
  var useRange = typeof value === 'number' && typeof secondValue === 'number';
  var hyphen = ' - ';
  var renderedValue = useRange ? value === secondValue ? "".concat(value) : "".concat(value).concat(hyphen).concat(secondValue) : typeof value === 'number' ? "".concat(value) : '';
  return /*#__PURE__*/_jsx("div", {
    className: classnames({
      [styles.coin]: true,
      [styles.small]: size === 'small',
      [styles.large]: size === 'large',
      [styles.circle]: renderedValue.indexOf(hyphen) === -1,
      [styles.pill]: renderedValue.indexOf(hyphen) > -1
    }),
    "data-e2e-name": "primary_coin",
    children: /*#__PURE__*/_jsx(Text, {
      "aria-label": label,
      role: "region",
      typog: "bodycopy",
      className: classnames({
        [styles.text]: true,
        [styles.textSmall]: size === 'small',
        [styles.textLarge]: size === 'large'
      }),
      children: "".concat(renderedValue)
    })
  });
};